// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from "../../../services/api";

const basketSearchService = async (data) => {
  return api(
    `/Sellitback.svc/SearchItem?UserID=${data.UserID}&CartID=${data.CartID}&EAN=${data.EAN}`,
    {},
    "GET"
  );
};

const basketService = async (data) => {
  return api(`/Sellitback.svc/GetCartDetails?cartId=${data.CartID}`, {}, "GET");
};

const basketRemoveItemService = async (data) => {
  return api(
    `/Sellitback.svc/RemoveItem?OrderDetailsID=${data.deleteItem.OrderDetailsID}&Token=${data.token}&CustomerId=${data.customerId}`,
    {},
    "GET"
  );
};

const cleanBasketService = async (data) => {
  return api(`/Sellitback.svc/ClearBasket?CartID=${data.CartID}`, {}, "GET");
};

const getCartIdService = async (data) => {
  return api(
    `/Sellitback.svc/GetCartID?CustomerId=${data.CustomerId}&Token=${data.Token}`,
    {},
    "GET"
  );
};

const getIsEligibleForHomePickupService = async (data) => {
  return api(
    `/Sellitback.svc/EligibleForHomePickup?cartId=${data.CartID}`,
    {},
    "GET"
  );
};

const getBasketNotificationsService = async (data) => {
  return api(
    `/Sellitback.svc/GetBasketNotifications?CartID=${data.CartID}`,
    {},
    "GET"
  );
};

export {
  basketService,
  basketSearchService,
  basketRemoveItemService,
  cleanBasketService,
  getCartIdService,
  getIsEligibleForHomePickupService,
  getBasketNotificationsService,
};

/**
 * The bookshop view of the same basket: books grouped under the voucher each
 * customer was issued, plus whatever is not yet vouchered.
 *
 * The ordinary basket call returns a flat list of lines with a VoucherId, but
 * nothing to put a name or a code against it. This is the call the app uses
 * for that screen, so both clients describe the basket the same way.
 */
export const getBookshopBasketService = async (data) => {
  return api('/Sellitback.svc/GetBookshopBasket', data, 'POST');
};
